import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../component/Header";
import CustomerSSidebar from "./components/CustomerSSidebar";
import Sidebar from "../../component/Sidebar";
import AnnualLeave from "../Admin/component/AnnualLeave";

const apiUrl = process.env.REACT_APP_API_URL;

const CustomerServiceAttendance = () => {
  const [log, setLog] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [userRole, setUserRole] = useState("");
  const [userName, setUserName] = useState("");

  const userId = localStorage.getItem("token");
  const now = new Date();
  const currentMonth = now.toISOString().slice(0, 7); // "YYYY-MM"

  function getLocalDateString() {
    const now = new Date();
    return (
      now.getFullYear() +
      "-" +
      String(now.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(now.getDate()).padStart(2, "0")
    );
  }

  function getLocalDateTimeString() {
    return new Date().toISOString().slice(0, 19).replace("T", " ");
  }

  const fetchTodayLog = async () => {
    try {
      const res = await axios.get(`${apiUrl}/api/attendance1/today/${userId}`, {
        headers: { Authorization: `Bearer ${userId}` },
      });
      setLog(res.data);
    } catch (err) {
      setError("Failed to load today’s record.");
    } finally {
      setLoading(false);
    }
  };

  const fetchHistory = async () => {
    try {
      const res = await axios.get(
        `${apiUrl}/api/attendance1/history/${userId}?month=${currentMonth}`,
        {
          headers: { Authorization: `Bearer ${userId}` },
        }
      );
      setHistory(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCheck = async () => {
    try {
      const res = await axios.post(
        `${apiUrl}/api/attendance1/${userId}`,
        {
          timestamp: getLocalDateTimeString(),
          date: getLocalDateString(),
        },
        {
          headers: { Authorization: `Bearer ${userId}` },
        }
      );

      setLog(res.data);
      setSuccess("Attendance marked successfully.");
      setError("");
      fetchHistory(); // refresh table
    } catch (err) {
      setError(err.response?.data?.error || "Check-in failed.");
      setSuccess("");
    }
  };

  const [groupedAttendance, setGroupedAttendance] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date();
    return now.toISOString().slice(0, 7); // "YYYY-MM"
  });

  useEffect(() => {
    const fetchAllAttendance = async () => {
      try {
        const res = await axios.get(
          `${apiUrl}/api/attendance1/all?month=${selectedMonth}`
        );
        const data = res.data;

        // Group by date
        const grouped = {};
        data.forEach((entry) => {
          if (!grouped[entry.date]) {
            grouped[entry.date] = [];
          }
          grouped[entry.date].push(entry);
        });

        setGroupedAttendance(grouped);
      } catch (err) {
        console.error("Error fetching all attendance:", err);
      }
    };

    fetchAllAttendance();
  }, [selectedMonth]);

  useEffect(() => {
    setUserName(localStorage.getItem("user"));
    setUserRole(localStorage.getItem("role"));
    fetchTodayLog();
    fetchHistory(); // Make this function to get full list
  }, []);

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  return (
    <>
      <Header />
      {userRole !== "Admin" && <CustomerSSidebar />}
      {(userRole === "Admin" || userName === "yeabkal") && <Sidebar />}
      {userName === "customerService" && <CustomerSSidebar />}

      <div className="mt-20 px-4 flex flex-row">
        <AnnualLeave />
        <div className="max-w-4xl mx-auto mt-20 px-4">
          {/* Attendance Panel */}
          <div className="bg-white rounded shadow-md p-6 mb-10">
            <h1 className="text-2xl font-bold text-center mb-6 text-gray-700">
              Employee Attendance
            </h1>

            {error && <p className="text-red-500 text-center mb-4">{error}</p>}
            {success && (
              <p className="text-green-600 text-center mb-4">{success}</p>
            )}

            {loading ? (
              <p className="text-center text-gray-600">Loading...</p>
            ) : (
              <div className="bg-gray-50 p-4 rounded-lg shadow text-center">
                {log?.check_in_time && (
                  <p className="text-md text-gray-700">
                    <strong>Check-In:</strong>{" "}
                    {new Date(log.check_in_time).toLocaleString("en-US", {
                      timeZone: "Africa/Addis_Ababa",
                      hour: "numeric",
                      minute: "numeric",
                      second: "numeric",
                      hour12: true,
                    })}
                  </p>
                )}

                {log?.check_out_time && (
                  <p className="text-md text-gray-700 mt-2">
                    <strong>Check-Out:</strong>{" "}
                    {new Date(log.check_out_time).toLocaleString("en-US", {
                      timeZone: "Africa/Addis_Ababa",
                      hour: "numeric",
                      minute: "numeric",
                      second: "numeric",
                      hour12: true,
                    })}
                  </p>
                )}
                {!log?.check_in_time && (
                  <button
                    className="w-full py-3 mt-4 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                    onClick={handleCheck}
                  >
                    Check In
                  </button>
                )}
                {log?.check_in_time && !log?.check_out_time && (
                  <button
                    className="w-full py-3 mt-4 bg-orange-500 text-white rounded hover:bg-orange-600 transition"
                    onClick={handleCheck}
                  >
                    Check Out
                  </button>
                )}
                {log?.check_in_time && log?.check_out_time && (
                  <p className="mt-4 text-gray-500">
                    You have checked in and out today.
                  </p>
                )}
              </div>
            )}
          </div>

          {/* History Table */}
          <div className="bg-white rounded shadow-md p-6">
            <h2 className="text-xl font-semibold text-gray-700 mb-4">
              This Month's Attendance
            </h2>
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm text-left">
                <thead>
                  <tr className="border-b border-gray-200 bg-gray-50 text-gray-600">
                    <th className="py-2 px-4">Date</th>
                    <th className="py-2 px-4">Check-In</th>
                    <th className="py-2 px-4">Check-Out</th>
                    <th className="py-2 px-4">Worked Hours</th>
                  </tr>
                </thead>
                <tbody>
                  {history.length === 0 ? (
                    <tr>
                      <td
                        colSpan="4"
                        className="py-4 text-center text-gray-400"
                      >
                        No records found.
                      </td>
                    </tr>
                  ) : (
                    history.map((entry) => {
                      const checkIn = entry.check_in_time
                        ? new Date(entry.check_in_time)
                        : null;
                      const checkOut = entry.check_out_time
                        ? new Date(entry.check_out_time)
                        : null;
                      const workedHours =
                        checkIn && checkOut
                          ? ((checkOut - checkIn) / (1000 * 60 * 60)).toFixed(2)
                          : "-";
                      return (
                        <tr
                          key={entry.id}
                          className="border-b border-gray-100 hover:bg-gray-50"
                        >
                          <td className="py-2 px-4">{entry.date}</td>
                          <td className="py-2 px-4">
                            {checkIn?.toLocaleTimeString("en-US", {
                              timeZone: "Africa/Addis_Ababa",
                              hour: "numeric",
                              minute: "numeric",
                              second: "numeric",
                              hour12: true,
                            }) || "-"}
                          </td>

                          <td className="py-2 px-4">
                            {checkOut?.toLocaleTimeString("en-US", {
                              timeZone: "Africa/Addis_Ababa",
                              hour: "numeric",
                              minute: "numeric",
                              second: "numeric",
                              hour12: true,
                            }) || "-"}
                          </td>

                          <td className="py-2 px-4">{workedHours}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
              {userName === "yeabkal" && (
                <div className="p-4 max-w-6xl mx-auto">
                  <h1 className="text-2xl font-bold mb-6">
                    All Employee Attendance
                  </h1>

                  <div className="mb-4">
                    <label className="font-medium mr-2">Select Month: </label>
                    <input
                      type="month"
                      value={selectedMonth}
                      onChange={(e) => setSelectedMonth(e.target.value)}
                      className="border p-2 rounded"
                    />
                  </div>

                  {Object.keys(groupedAttendance).length === 0 ? (
                    <p className="text-gray-500">
                      No records found for this month.
                    </p>
                  ) : (
                    Object.entries(groupedAttendance)
                      .sort(([a], [b]) => new Date(b) - new Date(a)) // Sort by date descending
                      .map(([date, records]) => (
                        <div
                          key={date}
                          className="mb-8 bg-white rounded shadow p-4"
                        >
                          <h2 className="text-xl font-semibold mb-4 text-blue-600">
                            {new Date(date).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })}
                          </h2>

                          <table className="min-w-full text-sm text-left">
                            <thead className="bg-gray-100 text-gray-700">
                              <tr>
                                <th className="py-2 px-4">Employee</th>
                                <th className="py-2 px-4">Check-In</th>
                                <th className="py-2 px-4">Check-Out</th>
                                <th className="py-2 px-4">Worked Hours</th>
                              </tr>
                            </thead>
                            <tbody>
                              {records.map((entry) => {
                                const checkIn = entry.check_in_time
                                  ? new Date(entry.check_in_time)
                                  : null;
                                const checkOut = entry.check_out_time
                                  ? new Date(entry.check_out_time)
                                  : null;
                                const workedHours =
                                  checkIn && checkOut
                                    ? (
                                        (checkOut - checkIn) /
                                        (1000 * 60 * 60)
                                      ).toFixed(2)
                                    : "-";

                                return (
                                  <tr
                                    key={entry.id}
                                    className="border-b hover:bg-gray-50"
                                  >
                                    <td className="py-2 px-4">
                                      {entry.user_name}
                                    </td>
                                    <td className="py-2 px-4">
                                      {checkIn?.toLocaleTimeString("en-US", {
                                        timeZone: "Africa/Addis_Ababa",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                        hour12: false,
                                      }) || "-"}
                                    </td>
                                    <td className="py-2 px-4">
                                      {checkOut?.toLocaleTimeString("en-US", {
                                        timeZone: "Africa/Addis_Ababa",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                        hour12: false,
                                      }) || "-"}
                                    </td>
                                    <td className="py-2 px-4">{workedHours}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      ))
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <DayoffPermission /> */}
      </div>
    </>
  );
};

export default CustomerServiceAttendance;
